export class CustomerModel {
  public customerHashId: string;
  public customerName: string;
  public description: string;
  public instanceCount: number;
  public roleCount: number;
  public adminCount: number;
  public isChecked: boolean;

  public isEditable: boolean;
  public isDeletable: boolean;
  public isAdminCount: boolean;
  public isInstanceCount: boolean;
  public isRoleCount: boolean;
  public isWegoAdmin : boolean;

  constructor() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/customer/models/customer.model.ts